<template>
    <el-dialog
    :visible.sync="detail.dialog"
    top="5vh"
    custom-class="dailogCustomerBase"
    width="70%"
    >
        <template slot="title">
            <h1 class="text-header">ข้อมูลแพ็กเกจลูกค้า</h1>
        </template>
        <el-tabs tab-position="left">
            <!-- <el-tab-pane v-for="item in MenuList" :key="item.id" :label="item.name"></el-tab-pane> -->
            <el-tab-pane label="Subscription QR Code"></el-tab-pane>
            <all-customer-detail
                :detail.sync="detail"
                @onClickCreateQrDialog="$emit('onClickCreateQrDialog', $event)"
                @onClickPaymentDetailDialog="$emit('onClickPaymentDetailDialog', $event)"
            ></all-customer-detail>
        </el-tabs>
    </el-dialog>
</template>

<script>
import AllCustomerDetail from '@/components/Customer/AllCustomer/AllCustomerDetail'
export default {
    name: 'allCustomerBase',
    components: {
        AllCustomerDetail
    },
    props: {
        detail: {
            type: Object,
            default: null
        }
    },
    data () {
        return {
            MenuList: [
                { id: 0, name: 'Subscription QR Code' },
                { id: 1, name: 'Rate card' }
            ]
        }
    }
}
</script>
<style lang="scss" scoped>
.text-header {
    margin:unset;
    text-align:left;
}
</style>
<style lang="scss">
.dailogCustomerBase {
    .el-dialog__header {
        background-color: teal;
        color: white;
        button {
            font-size: large;
            i {
                color: #ffffff;
                &:hover {
                    color: white;
                }
            }
        }
    }
}
</style>
